import { graphql } from 'react-relay';

export default graphql`
  mutation confirmEditionMutation(
    $input: PackageTrackerAddressUpdateMutationInput!
  ) {
    packageTrackerAddressUpdate(input: $input) {
      success
      privatePackageTracker {
        packageInfo {
          companyName
          packageId
        }
        recipientInfo {
          firstName
          originalPhone
        }
        destinationInfo {
          firstLine
          secondLine
          complement
          coordinates {
            lat
            lng
          }
        }
        permissions
      }
    }
  }
`;
